import { token } from '@/infrastructure/container';

export interface IIdGen {
  next(): string;
}

export const TOKEN_IIdGen = token<IIdGen>('IIdGen');

export class IdGen implements IIdGen {
  next(): string {
    return crypto.randomUUID();
  }
}
